import Modal from 'modal-vanilla';

const preloader = `
<span class="button__preloader">
  <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
  </svg>
</span>`;

const confirmFestiveAction = () => {
  const buttons = document.getElementsByClassName('js-festive-confirm');

  if (!buttons.length) return;

  const modalEntity = document.getElementById('festiveConfirmModal');
  const title = modalEntity.querySelector('.js-festive-confirm-title');
  const text = modalEntity.querySelector('.js-festive-confirm-text');
  const submit = modalEntity.querySelector('.js-festive-confirm-submit');

  [...buttons].forEach((button) => {
    button.addEventListener('click', () => {
      title.textContent = button.dataset.title;
      text.textContent = button.dataset.text;

      const onSubmit = () => {
        submit.disabled = true;
        submit.style.color = 'transparent';
        submit.insertAdjacentHTML('beforeend', preloader);
        document.getElementById(button.dataset.form).submit();
      };

      submit.onclick = onSubmit;

      new Modal({ el: modalEntity }).show();
    });
  });
};

export default confirmFestiveAction;
